import { ImpactModule } from 'types'
import { MESSENGER_PAGES } from './pages'
import { MESSENGER_PAGES_ORDER_FOR_PERMISSIONS } from './pagesOrderForPermissions'

export const MESSENGER_MODULE: ImpactModule = {
  NAME: 'admin',
  NAME_PTBR: 'Mensageria',
  UPPER_NAME: 'ADMIN',
  API_NAME: 'ADMIN',
  PAGES: MESSENGER_PAGES,
  PAGES_ORDER_FOR_PERMISSIONS: MESSENGER_PAGES_ORDER_FOR_PERMISSIONS,
}
